var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"game-timer",attrs:{"value":_vm.progress,"size":_vm.size,"width":"12","color":_vm.timerColour}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }